import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Що робити, якщо вручили повістку на вулиці?',
    answer: "Перш за все, не панікуйте. Перевірте правильність заповнення повістки (ПІБ, адреса, дата, підпис начальника ТЦК). Ви маєте право відмовитися від підпису, якщо повістка заповнена з помилками, але це має бути зафіксовано актом. Рекомендуємо одразу зв'язатися з адвокатом."
  }, {
    question: 'Чи можна оскаржити рішення ВЛК?',
    answer: 'Так, рішення ВЛК можна оскаржити до ЦВЛК (Центральної військово-лікарської комісії) або в судовому порядку. Для цього необхідно мати медичні документи, що підтверджують наявність захворювань, які не були враховані комісією.'
  }, {
    question: 'Які документи потрібні для отримання відстрочки?',
    answer: 'Перелік документів залежить від підстави для відстрочки (навчання, догляд за інвалідом, багатодітність тощо). Зазвичай це нотаріально завірені копії свідоцтв про народження дітей, довідок МСЕК, студентських квитків тощо. Наш адвокат допоможе сформувати точний пакет документів.'
  }, {
    question: 'Чи надаєте ви термінові консультації?',
    answer: "Так, ми розуміємо специфіку військових справ. Ви можете зв'язатися з нами через Telegram або WhatsApp для термінової консультації, навіть у вихідні дні."
  }, {
    question: 'Що загрожує за неявку по повістці?',
    answer: "За неявку по повістці для уточнення даних передбачена адміністративна відповідальність (штраф). За ігнорування 'бойової' повістки (на відправку) може настати кримінальна відповідальність (ст. 336 ККУ)."
  }, {
    question: 'Скільки коштують ваші послуги?',
    answer: 'Вартість залежить від складності справи. Первинна консультація коштує від 500 грн. Повний супровід справи розраховується індивідуально після ознайомлення з матеріалами.'
  }];
  return <Section id="faq" background="white" data-id="element-64">
      <div className="grid md:grid-cols-12 gap-8 md:gap-12 lg:gap-24" data-id="element-65">
        <div className="md:col-span-4" data-id="element-66">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black mb-6 md:mb-8" data-id="element-67">
            FAQ
          </h2>
          <p className="text-neutral-500 mb-6 md:mb-8 text-base md:text-lg font-light" data-id="element-68">
            Відповіді на найпоширеніші питання щодо мобілізації та військового
            права.
          </p>
          <a href="#contact" className="text-black font-medium text-sm border-b border-black pb-1 hover:text-neutral-600 hover:border-neutral-600 transition-colors inline-block" data-id="element-69">
            Задати своє питання
          </a>
        </div>

        <div className="md:col-span-8" data-id="element-70">
          {faqs.map((faq, index) => <div key={index} className="border-b border-neutral-200 last:border-0" data-id="element-71">
              <button className="w-full flex items-start justify-between py-5 md:py-6 text-left focus:outline-none group" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-72">
                <span className="font-medium text-base md:text-lg text-black pr-4 md:pr-8" data-id="element-73">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 mt-1" data-id="element-74">
                  {openIndex === index ? <Minus className="h-4 w-4 text-black" data-id="element-75" /> : <Plus className="h-4 w-4 text-neutral-400 group-hover:text-black transition-colors" data-id="element-76" />}
                </span>
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100 mb-5 md:mb-6' : 'max-h-0 opacity-0'}`} data-id="element-77">
                <div className="text-neutral-500 text-sm md:text-base leading-relaxed font-light max-w-2xl pr-4" data-id="element-78">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}